import React, { useState } from "react";
import useDidMountEffect from "../../customHooks/useDidMountEffect";
import HeDatePickerProps from "./HeDatePickerProps";
import { useTranslation } from "react-i18next";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import heLocale from "date-fns/locale/he";
import arLocale from "date-fns/locale/ar";
import DatePicker from "@mui/lab/DatePicker";
import { TextField } from "@mui/material";
import {
  isEnterPress,
  isTabPress,
} from "../../utils/helpers/accessibilityUtil";

import "./HeDatePicker.scss";
import { Label } from "reactstrap";

const localeMap = {
  he: heLocale,
  ar: arLocale,
};

const maskMap = {
  he: "dd/MM/yyyy",
  ar: "dd/MM/yyyy",
};

const getLang = () =>
  (localStorage.getItem("lang") as keyof typeof maskMap) || "he";

const HeDatePicker = (props: HeDatePickerProps) => {
  const [locale, setLocale] = useState<keyof typeof maskMap>(getLang());
  const [isOpen, setIsOpen] = useState<boolean | null>(null);
  const { t, i18n } = useTranslation("common");

  // const handleClickAway = (evl:any) => {
  //   // console.log("asd1===>" , isOpen)
  //   // if (isOpen === true) {
  //   //   setIsOpen(false);
  //   //   console.log("asd===>")
  //   //   props.isOpenFun(true);
  //   //   return;
  //   // }
  //   // if(isOpen === false){
  //   //   props.isOpenFun(false);
  //   //   return;
  //   // }
  //   // setIsOpen(true)
  //   console.log("asdasd", evl)
  // };

  useDidMountEffect(() => {
    if (i18n.language === "he") {
      setLocale("he");
    } else if (i18n.language === "ar") {
      setLocale("ar");
    }
  }, [i18n.language]);

  return (
    <div className="HeDatePicker-wrap">
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        locale={localeMap[locale]}
      >
        <div className="d-flex align-items-center deposits-date-picker-wrapper">
          <Label for={`id-${props.dateLabel}`}>{props.dateLabel}</Label>
          <DatePicker
            value={props.dateValue}
            views={["year", "month", "day"]}
            showToolbar={false}
            minDate={props.minDate || new Date("01/01/2007")}
            maxDate={props.maxDate || new Date()}
            PaperProps={dateTimePaperPropsStyles}
            inputFormat={"dd/MM/yyyy"}
            okText={t("general.accept")}
            cancelText={t("general.cancel")}
            disabled={props.isDisabled()}
            onClose={(): void => props.isOpenFun(true) && props.isOpenFun()}
            allowSameDateSelection
            onChange={(newValue) => props.setDateValue(newValue)}
            renderInput={(params) => (
              props.isDisabled() ?
              <TextField
              label={""}
              value={""}
              disabled={true}
              placeholder=""
              variant="standard"
              id={`id-${props.dateLabel}`}
            ></TextField> :
                <TextField
                  {...params}
                  label={""}
                  variant="standard"
                  onKeyDown={(e: any) =>
                    !(isTabPress(e) || isEnterPress(e)) && e.preventDefault()
                  }
                  name="datePickerInput"
                  id={`id-${props.dateLabel}`}
                // sx={{
                //   svg: { color: "#6c6c6d" },
                //   input: { width: "fit-content",color: "#",
                //   "& .Mui-disabled": {
                //     color: "#6c6c6d"
                //   } },
                //   label: { color: "#6c6c6d" }
                // }}
                />
                
            )}
          />
        </div>
      </LocalizationProvider>
    </div>
  );
};

const dateTimePaperPropsStyles = {
  sx: {
    ".MuiPickersCalendarHeader-root": {
      display: "flex",
      alignItems: "center",
      justifyItems: "center",
      width: "fit-content"
    },
    ".MuiPickersCalendarHeader-root:first-child": {
      order: 0,
      paddingRight: "20px",
      paddingLeft: "20px"
    },
    ".MuiPickersArrowSwitcher-root": {
      display: "inline-flex"
      // visibility: "hidden"
    },
    ".MuiPickersCalendarHeader-label": {
      textAlign: "center"
    },
    ".MuiPickersArrowSwitcher-spacer": {
      // width: "220px"
      with: "10px",
    },
    ".css-31ca4x-MuiPickersFadeTransitionGroup-root": {
      display: "flex",
      position: "absolute",
      paddingLeft: "80px"
    },
    ".css-9reuh9-MuiPickersArrowSwitcher-root": {
      marginLeft: "-2px"
    },
    ".MuiPickersArrowSwitcher-button": {
      paddingRight: "7px"
    }
  }
};

export default HeDatePicker;
